import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { isValidPatientId } from "utils/isValidPatientId";
import { pathGenerators } from "utils/routes";

// Redirects old id-in-query patient links to the new /patients/:patientId/*
// path form, so links already sent out (emails, SMS, payment links, bookmarks)
// keep working:
//   /patient/<tab>?patientId=123                     -> /patients/123/<tab>
//   /patient/consultation/edit/:id?patientId=123     -> /patients/123/consultation/edit/:id
// With no patientId in the query there is nothing to resolve, so fall back to
// the patient list.
const KNOWN_TABS = new Set([
  "details",
  "pregnancy",
  "cdm",
  "referrals",
  "documents",
  "communication",
  "payments",
  "family",
  "consult",
  "consultations",
  "results",
  "immunizations",
  "medication",
]);

export const LegacyPatientRedirect = () => {
  const { legacyTab, consultationId } = useParams();
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get("patientId");

  if (!isValidPatientId(patientId)) {
    return <Navigate to={pathGenerators.global.patient()} replace />;
  }

  if (consultationId) {
    return (
      <Navigate
        to={pathGenerators.patient.consultationEdit({
          patientId,
          consultationId,
        })}
        replace
      />
    );
  }

  if (legacyTab && KNOWN_TABS.has(legacyTab)) {
    return <Navigate to={`/patients/${patientId}/${legacyTab}`} replace />;
  }

  return <Navigate to={pathGenerators.global.patient()} replace />;
};
